import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostVorlageKopierenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostVorlageKopierenCommandService],
  exports: []
})
export class PostVorlageKopierenCommandServiceModule { }
